import { FC } from 'react';

import { Chip } from '@servicetitan/anvil2';
import { TableCellProps } from '@servicetitan/table';

import { OutboundMessage, MessageStatus } from '../api/telecom.api';
import { getMessageStatusDisplayName } from '../utils/enum-display.utils';

const statusColors: Record<MessageStatus, string> = {
    [MessageStatus.Delivered]: '#d4edda',
    [MessageStatus.SendingError]: '#f8d7da',
    [MessageStatus.Scheduled]: '#fff3cd',
    [MessageStatus.Sent]: '#d1ecf1',
    [MessageStatus.DeliveryError]: '#f8d7da',
    [MessageStatus.Sending]: '#e7f3ff',
};

const getStatusProps = (status: MessageStatus) => {
    return {
        color: statusColors[status] ?? '#e2e3e5',
        displayName: getMessageStatusDisplayName(status),
    };
};

export const StatusCell: FC<TableCellProps<OutboundMessage>> = ({ dataItem }) => {
    const { color, displayName } = getStatusProps(dataItem.messageStatus);

    return (
        <td>
            <Chip label={displayName} color={color} size="small" />
        </td>
    );
};
